import React from 'react';
import { colors } from '../theme/colors';

/**
 * Bank / Cash choice for salary disbursements (Payroll "Pay All" and Final
 * Settlement "Pay"). 2026-10-09.
 */
const OPTIONS = [
  { key: 'bank', label: 'Bank Payment' },
  { key: 'cash', label: 'Cash Payment' },
];

const PayMethodPicker = ({ value, onChange }) => (
  <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
    {OPTIONS.map(o => {
      const on = value === o.key;
      return (
        <button
          type="button"
          key={o.key}
          onClick={() => onChange(o.key)}
          style={{
            flex: 1, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14,
            border: on ? `2px solid ${colors.primary.main}` : '1px solid #CBD5E1',
            background: on ? `${colors.primary.main}10` : '#fff',
            color: on ? colors.primary.main : '#334155',
          }}
        >
          {o.label}
        </button>
      );
    })}
  </div>
);

export default PayMethodPicker;
